const SidebarActionTypes = {
  CHANGE_SIDEBAR_VISIBILITY: 'CHANGE_SIDEBAR_VISIBILITY',
  CHANGE_MOBILE_SIDEBAR_VISIBILITY: 'CHANGE_MOBILE_SIDEBAR_VISIBILITY',
};

export default SidebarActionTypes;
